export const TARGET_SYSTEM = "target_system";
export const REGISTER_COUNTRY = "register_country";
export const LAST_LOGIN_COUNTRY = "last_login_country";
export const MANDATORY_SEGMENT_ATTRIBUTES = new Set([TARGET_SYSTEM, REGISTER_COUNTRY, LAST_LOGIN_COUNTRY]);
